var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"notfound",attrs:{"shaped":"","elevation":"5"}},[_c('v-card-text',[_c('p',{staticClass:"justify display-3 font-weight-medium"},[_vm._v("\n      Sorry, page not found...\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }